import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import VueGlide from "vue-glide-js";
import "vue-glide-js/dist/vue-glide.css";
import Toasted from "vue-toasted";
import Vuex from "vuex";
import CKEditor from "ckeditor4-vue";

Vue.use(Toasted);
Vue.use(VueGlide);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(CKEditor);
Vue.use(Vuex);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
